import { Box } from '@mantine/core'
import React, { type PropsWithChildren } from 'react'

import { Navbar } from '../Navbar/Navbar'
import { NavbarSub } from '../Navbar/NavbarSub'
import classes from './styles.module.css'

export function AppShell({ children }: PropsWithChildren) {
  return (
    <Box className={classes.appShell}>
      <Navbar className={classes.appShellNavbar} />
      <NavbarSub className={classes.appShellNavbarSub} />
      <Box className={classes.appShellMain}>{children}</Box>
    </Box>
  )
}
